var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.024 15.651C14.222 15.651 16.01 13.863 16.01 11.665V5.986C16.01 3.788 14.222 2 12.024 2C9.82599 2 8.03799 3.788 8.03799 5.986V11.665C8.03799 13.863 9.82599 15.651 12.024 15.651ZM9.53799 5.986C9.53799 4.615 10.653 3.5 12.024 3.5C13.395 3.5 14.51 4.615 14.51 5.986V11.665C14.51 13.036 13.395 14.151 12.024 14.151C10.653 14.151 9.53799 13.036 9.53799 11.665V5.986Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.806 11.429C18.806 11.015 18.47 10.679 18.056 10.679C17.642 10.679 17.306 11.015 17.306 11.429C17.306 14.355 14.926 16.735 12 16.735C9.074 16.735 6.694 14.355 6.694 11.429C6.694 11.015 6.358 10.679 5.944 10.679C5.53 10.679 5.194 11.015 5.194 11.429C5.194 14.936 7.862 17.831 11.274 18.195V21.25C11.274 21.664 11.61 22 12.024 22C12.438 22 12.774 21.664 12.774 21.25V18.188C16.163 17.802 18.806 14.92 18.806 11.429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.ff66d562b852cf39a0bcf5ac901b5781.svg";
export { ForwardRef as ReactComponent };